import { Link } from 'react-router-dom';
import {
  Button as MuiButton, Grid, Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUserAdminStatus } from '@client/selectors/helpers/login';
import { DocumentTitle } from '@client/components/common/DocumentTitle';
import { LoadingMessage } from '@client/components/common/LoadingMessage';
import { SiteContainer } from '@client/components/common/SiteContainer';
import { ProfileTypes } from '@sda/enums';
import { getCoverImage } from '@sda/utils/image';
import { getNormalizedProfile } from '@sda/utils/meta';
import { withAct } from '@client/decorators/Public/withAct';
import { Profile } from '../Profile';

const useStyles = makeStyles()((theme) => ({
  toolbar: {
    marginBottom: theme.spacing(3),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
}));

export const Act = withAct({ fallback: LoadingMessage, useVanityUrl: true })(({ act, isOwnerOrCollaborator }) => {
  const { classes } = useStyles();
  const isAdmin = useSelector(getSessionUserAdminStatus);

  return (
    <SiteContainer maxWidth="narrow">
      <DocumentTitle
        title={act.name}
        description={act.bioHTML}
        image={getCoverImage(act.publicImageUrl)}
      />

      {isOwnerOrCollaborator && (
        <div className={classes.toolbar}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography variant="subtitle2">
                Profile
              </Typography>
            </Grid>

            <Grid item>
              <Grid
                container
                spacing={2}
              >
                {Boolean(isAdmin) && (
                  <Grid item>
                    <MuiButton
                      id="sda-edit-profile-button"
                      component={Link}
                      to={`/artists/${act.vanityUrl}/edit`}
                      color="primary"
                      variant="outlined"
                      startIcon={<ConstructionIcon />}
                    >
                      Admin
                    </MuiButton>
                  </Grid>
                )}

                <Grid item>
                  <MuiButton
                    id="sda-edit-profile-button"
                    component={Link}
                    to="/profile/edit"
                    color="primary"
                    variant="contained"
                  >
                    Edit Profile
                  </MuiButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}

      <Profile
        {...getNormalizedProfile(ProfileTypes.ACT, act)}
      />
    </SiteContainer>
  );
});

export default Act;
